import './UpcomingWebinarAdminControls.scss'

import ControlButton from 'pages/Home/admin/ControlButton/ControlButton'
import RecordedWebinarType from 'pages/Home/RecordedWebinarType'
import UpcomingWebinarType from 'pages/Home/UpcomingWebinarType'
import React, { useState } from 'react'

import AddUpcomingWebinarDialog from './AddUpcomingWebinarDialog'
import DeleteUpcomingWebinarDialog from './DeleteUpcomingWebinarDialog'

export interface UpcomingWebinarAdminControlsProps {
  recordedWebinars: RecordedWebinarType[]
  upcomingWebinar: UpcomingWebinarType
}

export default function UpcomingWebinarAdminControls(props: UpcomingWebinarAdminControlsProps) {
  const { recordedWebinars, upcomingWebinar } = props
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false)
  const [isDuplicateDialogOpen, setIsDuplicateDialogOpen] = useState(false)

  return (
    <div onClick={event => event.stopPropagation()}>
      <ControlButton className="upcoming-webinar-admin-controls__edit" onClick={() => setIsEditDialogOpen(true)} />
      <ControlButton
        className="upcoming-webinar-admin-controls__duplicate"
        variant="duplicate"
        onClick={() => setIsDuplicateDialogOpen(true)}
      />
      <ControlButton
        className="upcoming-webinar-admin-controls__delete"
        variant="delete"
        onClick={() => setIsDeleteDialogOpen(true)}
      />
      {isDeleteDialogOpen && (
        <DeleteUpcomingWebinarDialog
          onRequestClose={() => setIsDeleteDialogOpen(false)}
          upcomingWebinar={upcomingWebinar}
        />
      )}
      {isEditDialogOpen && (
        <AddUpcomingWebinarDialog
          onRequestClose={() => setIsEditDialogOpen(false)}
          initialUpcomingWebinar={upcomingWebinar}
          recordedWebinars={recordedWebinars}
        />
      )}
      {isDuplicateDialogOpen && (
        <AddUpcomingWebinarDialog
          onRequestClose={() => setIsDuplicateDialogOpen(false)}
          initialUpcomingWebinar={{
            ...upcomingWebinar,
            id: null,
            date: null,
            published: false,
            registrationLink: null
          }}
          recordedWebinars={recordedWebinars}
        />
      )}
    </div>
  )
}
